export default __webpack_public_path__ + "static/media/step_06.06d8d19d.png";